import { json_utils } from "../frfr-json-utils";




//
export const _zzyourmap_make_empty_special_blog_post_data = () => {
  return {
    is_editorjs: true,
    editorjs_data: null,
    editorjs_data_json: null,
  };
};


//
export const _zzyourmap_extract_editorjs_renderable_data = (_special_blog_post_data) => {
  let editorjs_renderable_data = null;
  if (_special_blog_post_data?.is_editorjs === true) {
    // editorjs_renderable_data = _special_blog_post_data.editorjs_data;
    const decoded = json_utils.decode_if_json(_special_blog_post_data.editorjs_data_json);
    console.log('decoded', decoded);
    if (decoded) {
      editorjs_renderable_data = decoded;
    }
  }
  return editorjs_renderable_data;
};


//
export const _zzyourmap_update_special_blog_post_data = (_special_blog_post_data, editorjs_renderable_data) => {
  let updated_special_blog_post_data = {
    // ..._special_blog_post_data,
    is_editorjs: true,
  };
  // updated_special_blog_post_data.editorjs_data = editorjs_renderable_data;
  updated_special_blog_post_data.editorjs_data_json = null;
  const json_encoded = json_utils.js_to_always_json(editorjs_renderable_data);
  if (json_encoded) {
    updated_special_blog_post_data.editorjs_data_json = json_encoded;
  }
  return updated_special_blog_post_data;
};

